<template>
  <div id="app">
    <div class="appHeader">
      <a href="https://awesome.hotspexeurope.com/"><img src="./assets/logo.png"></a>
    </div>

    <div class="row appContent">
        <div class="col-xs-12">
            <!-- <transition name="slide" mode="out-in">
                <router-view></router-view>
            </transition> -->
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
        </div>
    </div>

  </div>


</template>

<script>
  import ProjectHome from './components/ProjectHome.vue'

  export default {
    name: 'app',
    data () {
      return {
        isdropDownOpen: false
      }
    },
    components: {
      projectHome: ProjectHome
    }
  }
</script>

<style lang="scss">
  #appBlock
  {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
    z-index: 999;
  }

  .hidden
  {
    display: none;
  }

  .hideScrollbar
  {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    position: relative;

    min-width: 900px;
    max-width: 85%;
    margin: auto;
  }

  .appHeader
  {
    margin-top: 10px;
    height: 50px;
    text-align: left;
    padding-left: 15px;
  }

  .library
  {
    float: right;
    margin-top: 5px;
    font-weight: 700;
    
  }

  .dropdown-menu
  {
    padding: 0 5px;
  }

  .library a
  {
    display: inline-block;
    padding: 5px;
    line-height: 24px;
    font-weight: 500;
  }

  .library .dropdown-divider
  {
    height: 1px;
    border-top: 1px solid #aaa;
  }


  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    font-style: italic;
    color: #999;
  }
  ::-moz-placeholder { /* Firefox 19+ */
    font-style: italic;
    color: #999;
  }
  :-ms-input-placeholder { /* IE 10+ */
    font-style: italic;
    color: #999;
  }
  :-moz-placeholder { /* Firefox 18- */
    font-style: italic;
    color: #999;
  }

</style>



// WEBPACK FOOTER //
// App.vue?31cb0736